export const bannerTypes = Object.freeze({
  EARN_COMMISSION: 'earn_commission',
  COMMISSION_EXCHANGE: 'commission_exchange',
  WAYS_TO_EARN_COMMISSION: 'ways_to_earn_commission',
});

export const commissionItemTypes = Object.freeze({
  SIGN_UP: 'sign_up',
  UPLOAD_PROFILE_PICTURE: 'upload_profile_picture',
  READ_FAQ: 'read_faq',
  CREATE_COMMENT: 'create_comment',
  UPVOTE_POST_OR_COMMENT: 'upvote_post_or_comment',
  DOWNLOAD_MOBILE_APP: 'download_mobile_app',
  FILL_PROFILE: 'fill_profile',
} as const);

export const FAQPostUri = '/war-room/posts/faq';

export const commissionBannerTooltipName = 'war_room:comission_banner';

export const topicKinds = Object.freeze({
  COMMON: 'common',
  PROTECTED: 'protected',
});
